import {BuilderBankAccount} from '../../../../schema-types/BuilderBankAccount';

export const getBankName = (
  bankAccount: Pick<BuilderBankAccount, 'provider'>
): string | null =>
  bankAccount.provider?.formattedName || bankAccount.provider?.name || null;

export const getAccountName = (
  bankAccount: Pick<BuilderBankAccount, 'accountName' | 'contact'>
): string | null =>
  bankAccount.accountName || bankAccount.contact?.simplifiedName || null;

export const getBankAccountDisplayName = (
  bankAccount: Pick<BuilderBankAccount, 'name' | 'accountName' | 'provider'>
): string =>
  bankAccount.accountName ||
  bankAccount.name ||
  getBankName(bankAccount) ||
  'Bank account';

export const getSortCode = (sortCode: string | null) => {
  const s = sortCode?.replaceAll('-', '');
  if (!s || s.length !== 6) {
    return 'N/A';
  }
  return `${s.substring(0, 2)}-${s.substring(2, 4)}-${s.substring(4)}`;
};
